import $ from 'jquery';
import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import {showDuplicateLoginAlert} from '../../components/Auth/DuplicateLoginAlert';
//import { decode as base64_decode } from 'base-64';

const ajaxWebhookEvent = (type, ll, dd, tk, rejectMessage, pp = 'webhooks') => {
  return new Promise(function (resolve, reject) {
    try {
      $.ajax({
        url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
        type,
        dataType: 'text',
        headers: {
          'Authorization': 'Bearer ' + tk,
        },
        data: {
          pp: base64_encode(pp),
          ll: base64_encode(ll),
          dd: base64_encode(JSON.stringify(dd)),
          tk,
        },
        success: function (data) {
          
          
          let decoded;
          try {
            decoded = base64_decode(data);
            data = JSON.parse(decoded);
            resolve([200, data]);
          } catch (e) {
            reject([500, {message: 'Erro ao processar resposta do servidor'}]);
          }
        },
        error: function (xhr, status, error) {
          console.error('Erro AJAX:', {xhr});
          if (xhr?.message === 'erro_auth') {
            showDuplicateLoginAlert();
          }
          reject([400, {message: rejectMessage}]);
        },
      });
    } catch (err) {
      reject([500, {message: 'Server Error'}]);
    }
  });
};

const RestWebhooksPost = (config) => {
  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  switch (caminho) {
    case 'webhook_cadastrar':
    case 'webhookCadastrar':
    case 'webhook_create':
      return ajaxWebhookEvent('POST', 'webhook_cadastrar', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost || {}))], token, 'Erro ao cadastrar webhook');
    case 'webhook_deletar':
    case 'webhookDeletar':
    case 'webhook_delete':
      return ajaxWebhookEvent('POST', 'webhook_deletar', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))], token, 'Erro ao deletar webhook');
    case 'webhook_disparar_teste':
    case 'webhookDispararTeste':
      return ajaxWebhookEvent('POST', 'webhook_disparar_teste', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost || {}))], token, 'Erro ao disparar teste do webhook');
    case 'apiv1_try':
      return ajaxWebhookEvent('POST', 'apiv1_try', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost || {}))], token, 'Erro ao testar API');
    default:
      return new Promise((resolve) => resolve([404, {message: 'Rota não encontrada'}]));
  }
};

const RestWebhooksGet = (config) => {

  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];
  const acao = config?.params?.dest || '';
  switch (acao) {
    case 'webhook_listar':
    case 'webhookListar':
    case 'webhook_list':
      return ajaxWebhookEvent('POST', 'webhook_listar', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify({}))], token, 'Erro ao listar webhooks');
    case 'webhook_eventos':
    case 'webhookEventos':
    case 'webhook_events':
      return ajaxWebhookEvent('POST', 'webhook_eventos', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify({}))], token, 'Erro ao listar eventos dos webhooks');
    case 'webhook_entregas':
    case 'webhookEntregas':
    case 'webhook_logs':
      return ajaxWebhookEvent('POST', 'webhook_entregas', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify({}))], token, 'Erro ao listar entregas dos webhooks');
    case 'api_list':
      return ajaxWebhookEvent('GET',  'api_list',        [base64_encode(emp), base64_encode(uid)],token,'Erro ao listar APIS');
      default:
      return new Promise((resolve) => resolve([404, {message: 'Rota não encontrada: '}]));
  }
};

export { RestWebhooksPost, RestWebhooksGet };
